var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHamburgerMenu(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 5C0 2.23858 2.23858 0 5 0H51C53.7614 0 56 2.23858 56 5C56 7.76142 53.7614 10 51 10H5C2.23858 10 0 7.76142 0 5ZM0 28C0 25.2386 2.23858 23 5 23H51C53.7614 23 56 25.2386 56 28C56 30.7614 53.7614 33 51 33H5C2.23858 33 0 30.7614 0 28ZM5 46C2.23858 46 0 48.2386 0 51C0 53.7614 2.23858 56 5 56H51C53.7614 56 56 53.7614 56 51C56 48.2386 53.7614 46 51 46H5Z",
    fill: "#FFFFFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHamburgerMenu);
export default __webpack_public_path__ + "static/media/icon-hamburger-menu.bee993233f861316df5028cf9ef299d7.svg";
export { ForwardRef as ReactComponent };